<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">修改密码</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <ul>
                    <li class="item">
                        <span>账号</span>
                        <span>{{accoutNum}}</span>
                    </li>
                    <li class="item">
                        <span>原始密码</span>
                        <input type="text" v-model="oldpass" maxlength="12" minlength="6" placeholder="请输入原始密码">
                    </li>
                    <li class="item">
                        <span>新密码</span>
                        <input type="text" v-model="newpass" maxlength="12" minlength="6" placeholder="请输入新密码">
                    </li>
                    <li class="item">
                        <span>确认密码</span>
                        <input type="text" v-model="repass" maxlength="12" minlength="6" placeholder="再次填写确认">
                    </li>
                </ul>
            </div>
            <div>
                <button class="button" @click="commitPass">确认并提交</button>
            </div>
        </div>
    </div>
</template>
<script>
import { updateUserPasswdAction } from "../../assets/js/api"
import { Toast } from "mint-ui";
import { Navbar, TabItem } from 'mint-ui';

export default {
    name: 'modifyPassword',
  data() {
    return {  
        accoutNum:123456456,    //账号
        oldpass:'',    //密码
        newpass:'',    //新密码
        repass:'',  //确认密码
        isOldPass:false,    //是否为旧密码
    };
  },
  computed: {},
  components: {},
  methods: {
      //提交新密码
      commitPass(){
          //获取原始密码
          if(this.oldpass.trim == ''){
              Toast:Toast({
                message:"请输入原始密码",
                position: 'middle',
                duration: 2500,
            })
            return
          }
          //密码长度应为6到12个字符
          var regul = /^[a-zA-Z0-9]\w{5,11}$/;
          if(regul.test(this.newpass)){
              //判断两次输入密码是否相同
              if(this.newpass == this.repass){
                updateUserPasswdAction(this.oldpass, this.newpass)
                .then(res => {
                    console.log("提交修改",res);
                    if (res.s == 0) {
                        Toast:Toast({
                            message:"修改成功",
                            position:"middle",
                            duration: 2500,
                        })
                        this.$router.back()
                    }
                })
                .catch(err => {
                    Toast:Toast({
                        message:"网络不给力，请稍后重试",
                        position:"middle",
                        duration: 2500,
                    })
                })
              }else{
                  Toast:Toast({
                        message:"两次输入密码不一样",
                        position:"middle",
                        duration: 2500,
                    })
              }
          }else{
              Toast:Toast({
                message:"密码长度应为6到12个字符",
                position:"middle",
                duration: 2500,
            })
          }
      }
  }          
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0,1);
    margin-top: 0.5rem;
    font-size: 0.55rem;
    margin-right: 0.6rem
}
.minContent{
    background-color: #fff;
    margin-top: 0.26rem;
}
.item{
    font-size: 0.42rem;
    color: rgba(0, 0, 0,0.7);
    line-height: 0.61rem;
    width: 94%;
    height: 0.97rem;
    margin-left: 0.61rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0,0.1);
    position: relative;
}
.item :nth-child(1){
    position: absolute;
    top: 0.2rem;
}
.item :nth-child(2){
    height: 0.68rem;
    position: absolute;
    top: 0.2rem;
    right: 0.84rem;
    color: rgba(0, 0, 0,0.5);
    border: none;
    text-align: right;
}
.forgetPass{
    background-color: rgba(241, 241, 241, 1);
    color: rgba(41, 158, 173, 1);
    font-size: 0.37rem;
    text-align: right;
    padding-top: 0.18rem;
    padding-right: 0.53rem;
}
.button{
    width: 6.71rem;
    height: 1.05rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    color: #fff;
    font-size: 0.42rem;
    border-radius: 0.16rem;
    position: relative;
    left: 15%;
    top: 0.79rem;
    border: 0.03rem solid rgba(255, 255, 255, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/modifyPassword.vue